import { useState, useEffect } from 'react'
import { localStorage } from 'react-storage'

import { ViewPreference } from '@src/routes/SearchResults/SearchResults'
import { createPersistentStorage } from '@src/utils/createPersistentStorage'
import { sendPricingAvailabilityInteractionEventNewSrp } from '@src/utils/analytics/pricingAndAvailability'

export const useViewPreference = (product) => {
  const [view, setView] = useState<ViewPreference | null>(null)

  const pdpViewPreference = createPersistentStorage<ViewPreference>(
    localStorage,
    'PDP_VIEW_PREFERENCE'
  )

  const handleSelectView = (selectedView: ViewPreference) => {
    sendPricingAvailabilityInteractionEventNewSrp({
      action: selectedView ? 'switch to list view' : 'switch to box view',
      section: 'p&a',
      component: 'body',
      elementType: 'icon',
      elementText: 'change view',
      product,
    })
    setView(selectedView)
    pdpViewPreference.set(selectedView)
  }

  useEffect(() => {
    const savedViewPreference = pdpViewPreference.get()
    if (savedViewPreference) {
      return setView(savedViewPreference)
    }
    setView(ViewPreference.grid)
  }, [])

  return {
    view,
    handleSelectView,
  }
}
